module.exports = __webpack_public_path__ + "static/media/monkey.6c78abcf.gif";